// JavaScript Document
//components/signs/Signs.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { InputAdornment, TextField, IconButton, Menu, MenuItem, AppBar, Box, Dialog, Typography, Tooltip} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import WrenchIcon from '@material-ui/icons/Build';
import Editor from './Editor';
import merge from 'deepmerge';

const useStyles = makeStyles((theme) => ({
    headerText : {
        fontSize: '1.2rem',
        minWidth: 200,
        padding : theme.spacing(1),
        margin: 'auto'
    }
}))


export default function ViewBar(props) {
    //classes
    const classes = useStyles();
    //inherited props from parent
    const {views, selected, search, onChange, onSearch, onUpdate, handleSend, user, organization, fields, label, selectedRows, bulkActions, onBulkAction} = props;
    //wrench menu anchor
    const [menuAnchor, setMenuAnchor] = React.useState(null);
    //dialog editor open state
    const [editorOpen, setEditorOpen] = React.useState(false);
    //current view
    const [view, setView] = React.useState(null);
    //Bulk action selection 
    const [bulkAction, setBulkAction] = React.useState('');
    //transform and open origin of wrench menu
    const menuOrigins = {
		vertical: 'top',
		horizontal: 'right'
	};

    //Handle changing view (dropdown)
    const handleChangeView = (e) => {
        //set the local view variable
        setView(views.find(n => n.id === e.target.value));
        //change in parent
        return onChange(e.target.value);
    }

    //handle changes to search filter
    const handleSearch = (e) => {
        onSearch(e.target.value);
    }

    //wrench clicked, open menu
    const handleOpenMenu = (e) => {
        setMenuAnchor(e.currentTarget)
    }

    //close wrench menu
    const handleCloseMenu = (e) => {
        setMenuAnchor(null);
    }

    //compute permission for current edit permission
    const viewPermission = () => {
        if(!view) return false;
        //view was created by current user
        if(view.createdBy === user.id) return true;
        //user is super admin
        if(user.usergroup === 1) return true;
        return false;
    }

    //wrench menu items
    const menuItems = () => {
        //console.log('user', user, 'organization', organization);
        //start list
        let items = [
            (<MenuItem key={1} onClick={handleNewView}>New view</MenuItem>)
        ];
        //anyone can make a view default
        if(selected) items.push(<MenuItem key={2} onClick={handleMakeDefault}>Make default</MenuItem>)
        //selected view has an ID and user has edit permission, they can edit & delete
        if(selected && viewPermission()) items.push((<MenuItem key={3} onClick={handleEditView}>Edit view</MenuItem>))
        if(selected && viewPermission()) items.push((<MenuItem key={4} onClick={handleDeleteView}>Delete view</MenuItem>))
        return items;
    }

    //make the currently selected view default
    const handleMakeDefault = (e) => {
        if(!selected) return false;
        handleSend({
            vso: 'preference',
            preference : {
                prf_user : user.id,
                prf_table : 'listview',
                prf_name : view.lv_table,
                prf_value : selected,
                prf_int : selected
            },
            subaction : 'save'
        });
        handleCloseMenu();
    }

    //delete the selected view
    const handleDeleteView = (e) => {
        //get index of selected view
        let index = views.findIndex(n => n.id === selected);
        //copy views
        let newViews = Object.assign([], views);
        //remove view from list
        newViews.splice(index, 1);
        //update the list
        onUpdate(newViews);
        //send delete call to server
        handleSend({
            vso: 'view',
            view: selected,
            subaction: 'delete'
        });
        //close the menu
        handleCloseMenu();
    }

    //crteate a new view based on the currently selected one
    const handleNewView = (e) => {
        //copy the current view replacing attributes
        let newView = merge(views.find(n => n.id === selected), {
            id : null,
            //createdBy : user.id,
            sharing : 'private',
            lv_name : 'My new view',
            organization : organization.id
        });
        //console.log(newView);
        //set the current view to the one being edited
        setView(newView);
        //close the wrench menu
        handleCloseMenu();
        //open the editor
        setEditorOpen(true);
    }

    //when edit view is clicked
    const handleEditView = (e) => {
        //close the wrench meno
        handleCloseMenu();
        //open the editor dialog
        setEditorOpen(true);
    }

    //close editor dialog
    const handleEditorClose = (e) => {
        setEditorOpen(false);
    }

    //When the view is saved
    const onViewSave = (newview) => {
        //if it's an existing view
        if(Boolean(newview.id)){
            //find the index of the view
            let index = views.findIndex(n => n.id === newview.id);
            //copy views
            let newViews = Object.assign([], views);
            //update view
            newViews[index] = newview;
            //update views in UI
            onUpdate(newViews);
            //close the editor
            handleEditorClose();
        } 
        //save the view
        handleSaveView(newview);
    }
    
    //Save the view to db/server
    const handleSaveView = (newview) => {
        //call to server to save view
        handleSend({
            vso: 'view',
            view: newview,
            subaction: 'save'
        }, (data) => {
            //if it's a new view
            if(!newview.id){
                //parse strings
                if(typeof data.view.lv_fields === 'string') data.view.lv_fields = JSON.parse(data.view.lv_fields);
                if(typeof data.view.lv_filter === 'string') data.view.lv_filter = JSON.parse(data.view.lv_filter);
                if(typeof data.view.lv_sort === 'string') data.view.lv_sort = JSON.parse(data.view.lv_sort);
                //add new view to list
                views.push(data.view);
                //set the current view
                setView(data.view);
                //update the list
                onUpdate(views);
                //close the editor
                handleEditorClose();
            }
        });
    }

    //render the toolbar
    return (
        <div>
            <Menu
                id="view-menu"
                anchorEl={menuAnchor}
                anchorOrigin={menuOrigins}
                keepMounted
                transformOrigin={menuOrigins}
                open={Boolean(menuAnchor)}
                onClose={handleCloseMenu}
            >
                {menuItems()}
            </Menu>
            <Dialog open={editorOpen} onClose={handleEditorClose}>
                <Editor view={view} onCancel={handleEditorClose} onSave={onViewSave} user={user} organization={organization} fields={fields} />
            </Dialog>
			<AppBar position="static" color="default" style={{paddingTop:5}}>
			    <Box display="flex">
                    {selectedRows.size > 0 && (
                        <TextField
                            id="bulk_actions_menu_view"
                            margin="none"
                            size="small"
                            name="bulk_actions_menu"
                            label={["With Selected (", selectedRows.size, ")"].join('')}
                            variant="outlined"
                            fullWidth
                            select
                            value={bulkAction}
                            onChange={(e) => {
                                const value = e.target.value;
                                setBulkAction(value);
                                onBulkAction(value);
                                //reset to placeholder
                                queueMicrotask(() => {
                                    //reset selection
                                    setBulkAction('');
                                    //remove focus
                                    document.activeElement?.blur();
                                    //bulkActionRef.current?.blur();
                                });
                            }}
                            
                        >
                            {bulkActions.map(n => (
                                <MenuItem
                                    key={n.id}
                                    value={n.id}
                                >
                                    <Tooltip
                                        title={n.af_description || ''}
                                        placement="right"
                                        arrow
                                    >
                                        <div style={{
                                            width: '100%',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }}>
                                            {n.af_label}
                                        </div>
                                    </Tooltip>
                                </MenuItem>
                            ))}
                        </TextField>
                    )}
                    {label ? (<Typography className={classes.headerText}>{label}</Typography>) : ''}
				    <TextField
					    id="select_view"
					    margin="none"
					    size="small"
					    name="view"
					    label="View"
					    variant="outlined"
					    value={selected}
					    onChange={handleChangeView}
					    fullWidth
					    select
				    >
					    {views.map((row) => (
					    <MenuItem value={row.id} key={row.id}>{row.lv_name}</MenuItem>
					    ))}
				    </TextField>
                    <IconButton 
                       size="small"
                       onClick={handleOpenMenu}
                    >
                        <WrenchIcon />
                    </IconButton>
				    <TextField
               		    size="small"
               		    margin="none"
               		    id="view-search"
               		    type="search"
               		    placeholder={"Search "+( label ? label : 'this list' ) + '...'}
               		    InputProps={{
                  		    startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>
               		    }}
            		    value={search}
               		    variant="outlined"
            		    onChange={handleSearch}
					    fullWidth
                    />
				</Box>
			</AppBar>
        </div>
    );
}
